import { z } from 'zod';

// Ce qui est a moi (lot F, 2026-08-27) : me renommer, renommer le foyer, partir.

export const renommageCompteSchema = z.object({
  displayName: z
    .string()
    .trim()
    .min(1, 'Le nom est obligatoire')
    .max(100, 'Le nom est trop long'),
});

export const renommageFoyerSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Le nom du foyer est obligatoire')
    .max(100, 'Le nom est trop long'),
});

/**
 * Supprimer son compte : le mot de passe est EXIGE.
 *
 * Pas de `passwordSchema` ici — on verifie une identite, on n'en cree pas une. Imposer
 * dix caracteres a la verification refuserait un compte ancien dont le mot de passe est
 * plus court, et le rendrait indestructible.
 */
export const suppressionCompteSchema = z.object({
  password: z.string().min(1, 'Ton mot de passe est obligatoire'),
});

export type RenommageCompte = z.infer<typeof renommageCompteSchema>;
export type RenommageFoyer = z.infer<typeof renommageFoyerSchema>;
